'use client';
import React from 'react'
import LogoDecorationMotif from '../LogoDecorationMotifs/LogoDecorationMotif'

type HeadlineAlignment = "left" | "center" | "right"

interface SubheadingProps {
	subheading: string
	size: number
	textColor?: string
	alignment?: HeadlineAlignment
	language?: 'english' | 'arabic'
}

const ALIGNMENT_TO_FLEX: Record<HeadlineAlignment, string> = {
	"left": "justify-start",
	"center": "justify-center",
	"right": "justify-end",
}

const SIZE_TO_TEXT_STYLE: Record<number, string> = {
	24: 'text-16-to-14--wide--alexandria',
	20: 'text-14--wide--alexandria',
	16: 'text-12--wide--alexandria',
}

const SIZE_TO_GAP: Record<number, string> = {
	24: '0.75rem',
	20: '0.75rem',
	16: '0.625rem',
}

const SIZE_TO_GAP_CENTER: Record<number, string> = {
	24: '1.5rem',
	20: '1rem',
	16: '0.75rem',
}

const SIZE_TO_HEIGHT: Record<number, string> = {
	24: '1.5rem',
	20: '1.25rem',
	16: '1rem',
}

const Subheading: React.FC<SubheadingProps> = ({
	subheading,
	size,
	alignment = "left",
	textColor = "text-text-quaternary",
	language = "english"
}) => {
	const shouldNegate = alignment === "center" && language === 'arabic';

	const leftMotifRight = shouldNegate ? false : alignment === "left";
	const rightMotifRight = shouldNegate ? true : alignment === "center";

	return (
		<div 
			style={{
				gap: alignment === "center" ? SIZE_TO_GAP_CENTER[size] : SIZE_TO_GAP[size],
			}}
			className={`
				flex flex-row
				items-center
				${ALIGNMENT_TO_FLEX[alignment]}
			`}
		>
			{
				(alignment !== "right") &&
				<LogoDecorationMotif right={leftMotifRight} height={SIZE_TO_HEIGHT[size]} />
			}
			<p className={`
				${SIZE_TO_TEXT_STYLE[size]}
				${textColor}
				`}>
				{subheading.toUpperCase()}
			</p>
			{
				(alignment !== "left") &&
				<LogoDecorationMotif right={rightMotifRight} height={SIZE_TO_HEIGHT[size]} />
			}
		</div>
	);
}

export default Subheading;
